<div class="details" data-testid="details">
    @if (!techmagicHide()) {
        <div class="details__screenshot" data-testid="details-screenshot">
            <div class="details__screenshot-container" data-testid="details-screenshot-container">
                <div class="details__screenshot-icons" data-testid="details-screenshot-icons">
                    <div class="icon" data-testid="icon">
                        <svg>
                            <use [attr.href]="spritePath + '#' + icons.screenshot"></use>
                        </svg>
                    </div>
                    <div class="icon" data-testid="icon">
                        <svg>
                            <use [attr.href]="spritePath + '#' + icons.outlineTrash"></use>
                        </svg>
                    </div>
                </div>
                <div class="details__screenshot-image" data-testid="details-screenshot-image"></div>
            </div>
        </div>
    }

    @if (showGraph()) {
        <div class="details__graph" data-testid="details-graph">
            <div class="details__graph-line" data-testid="details-graph-line">
                <ntv-graph [config]="lineGraphConfig"></ntv-graph>
            </div>
            <div class="details__graph-bar" data-testid="details-graph-bar">
                <ntv-graph [config]="barGraphConfig"></ntv-graph>
            </div>
        </div>
    }

    <div class="details__player-info" data-testid="details-player-info">
        <div class="player__text" data-testid="player-text">
            <div class="status-screen" data-testid="status-screen">
                <ntv-card variant="elevated" rounded="xl" shadow="md">
                    <div class="player-status" data-testid="player-status">
                        <h3>Pi and Player Status</h3>
                        <div class="status-items" data-testid="status-items">
                            @if (isLoading()) {
                                @for (item of playerStatusSkeletonItems(); track item) {
                                    <div class="status-item" data-testid="status-item-skeleton">
                                        <ntv-skeleton
                                            width="75px"
                                            height="12px"
                                            borderRadius="4px" />
                                        <ntv-skeleton
                                            width="92px"
                                            height="14px"
                                            borderRadius="4px" />
                                    </div>
                                }
                            } @else {
                                @for (status of playerStatus(); track $index) {
                                    <div class="status-item" data-testid="status-item">
                                        <span class="label">{{ status.label }}</span>
                                        <span
                                            class="value"
                                            [class.online]="status.value === 'ONLINE'"
                                            [class.offline]="status.value === 'OFFLINE'"
                                            >{{ status.value }}</span
                                        >
                                    </div>
                                }
                            }
                        </div>
                    </div>
                </ntv-card>

                @if (!techmagicHide()) {
                    <ntv-card variant="elevated" rounded="xl" shadow="md">
                        <div class="screen-info" data-testid="screen-info">
                            <h3>Screen Info</h3>
                            <div class="screen-details" data-testid="screen-details">
                                <div class="column" data-testid="column">
                                    <div class="status-item" data-testid="status-item">
                                        <span class="label">Screen Name</span>
                                        <span class="value">{{ screenInfo().screenName }}</span>
                                    </div>
                                    <div class="status-item" data-testid="status-item">
                                        <span class="label">Screen Template</span>
                                        <span class="value">{{ screenInfo().screenTemplate }}</span>
                                    </div>
                                </div>
                                <div class="column" data-testid="column">
                                    <div class="status-item" data-testid="status-item">
                                        <span class="label">Screen Playlist</span>
                                        <ul class="playlist-list">
                                            @for (
                                                item of screenInfo().screenPlaylist;
                                                track $index
                                            ) {
                                                <li>{{ item.label }} - {{ item.value }}</li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ntv-card>
                }
            </div>

            <div data-testid="div-24">
                <ntv-card variant="elevated" rounded="xl" shadow="md">
                    <div class="system-info" data-testid="system-info">
                        <div class="section-header" data-testid="section-header">
                            <h3>System Info</h3>
                            <div class="speedtest-info" data-testid="speedtest-info">
                                <div class="text-group" data-testid="text-group">
                                    <span class="label">Last Speedtest</span>
                                    @if (isLoading()) {
                                        <ntv-skeleton
                                            width="120px"
                                            height="14px"
                                            borderRadius="4px" />
                                    } @else {
                                        <span class="value">{{ lastSpeedtest() }}</span>
                                    }
                                </div>
                                @if (!techmagicHide()) {
                                    <div class="icon-refresh" data-testid="icon-refresh">
                                        <svg>
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons.refreshGreen
                                                "></use>
                                        </svg>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="status-items" data-testid="status-items">
                            @if (isLoading()) {
                                @for (item of systemInfoSkeletonItems; track item) {
                                    <div class="status-item" data-testid="status-item-skeleton">
                                        <ntv-skeleton
                                            width="92px"
                                            height="12px"
                                            borderRadius="4px" />
                                        <ntv-skeleton
                                            width="110px"
                                            height="14px"
                                            borderRadius="4px" />
                                    </div>
                                }
                            } @else {
                                @for (info of systemInfo(); track $index) {
                                    <div class="status-item" data-testid="status-item">
                                        <span class="label">{{ info.label }}</span>
                                        <span
                                            class="value"
                                            [class.online]="info.value === 'GOOD'"
                                            [class.offline]="info.value === 'BAD'"
                                            >{{ info.value }}</span
                                        >
                                    </div>
                                }
                            }
                        </div>
                    </div>
                </ntv-card>
            </div>

            @if (!techmagicHide()) {
                <div class="other-details" data-testid="other-details">
                    <ntv-card variant="elevated" rounded="xl" shadow="md">
                        <div class="other-details__content" data-testid="other-details-content">
                            <h3>Other Details</h3>
                            <div class="other-details__items" data-testid="other-details-items">
                                <div class="status-item" data-testid="status-item">
                                    <span class="label">Host Notes</span>
                                    <span class="value">No notes available</span>
                                </div>
                                <div class="status-item" data-testid="status-item">
                                    <span class="label">Picture</span>
                                    <span class="value">No pictures available</span>
                                </div>
                                <div class="status-item" data-testid="status-item">
                                    <span class="label">Tickets</span>
                                    <span class="value">No tickets available</span>
                                </div>
                            </div>
                        </div>
                    </ntv-card>
                </div>
            }
        </div>
        <div class="player__content" data-testid="player-content">
            <ntv-card variant="elevated" rounded="xl" shadow="md">
                <div class="player-content" data-testid="player-content">
                    <h3>Playlist Content</h3>
                    @if (playlistName()) {
                        <p class="playlist-name" data-testid="details-concept-playlist-name">
                            Playlist Name:
                            <a
                                class="playlist-name__link"
                                role="button"
                                tabindex="0"
                                [title]="playlistName()"
                                (click)="onPlaylistNameClick()"
                                (keydown.enter)="onPlaylistNameClick()"
                                (keydown.space)="onPlaylistNameClick()">
                                {{ playlistName() }}
                            </a>
                        </p>
                    }
                    <div class="playlist-content" data-testid="playlist-content">
                        @if (playlistContent().length === 0) {
                            <div
                                class="playlist-content__empty"
                                data-testid="playlist-content-empty">
                                <app-empty
                                    title="No playlist content found"
                                    description="This license does not have any playlist contents yet."
                                    animationName="No Items Found.json"
                                    animationWidth="15rem"
                                    animationHeight="15rem" />
                            </div>
                        } @else {
                            @for (item of playlistContent(); track item.id) {
                                <ntv-thumbnail-item
                                    [item]="item"
                                    size="sm"
                                    [disableRightClick]="true"
                                    [menuOptionVisible]="false"
                                    [showActionButtons]="false"
                                    [eyeIconVisible]="true"
                                    [showThumbnailInfoTag]="false"
                                    (viewClick)="onEyeIconClick($event)"></ntv-thumbnail-item>
                            }
                        }
                    </div>
                    @if (playlistHasMore()) {
                        <div class="playlist-content__more" data-testid="playlist-content-more">
                            <ntv-button
                                variant="accent"
                                size="sm"
                                [disabled]="isLoadingMorePlaylist()"
                                (buttonClick)="loadMorePlaylist()">
                                {{ isLoadingMorePlaylist() ? 'Loading...' : 'Show More' }}
                            </ntv-button>
                        </div>
                    }
                </div>
            </ntv-card>
        </div>
    </div>
</div>

<!-- Media Details Modal -->
@if (showMediaDetailsModal() && selectedItem()) {
    <app-media-details-modal
        [isVisible]="showMediaDetailsModal()"
        [item]="selectedItem()"
        [contents]="$any(playlistContent())"
        (modalClose)="showMediaDetailsModal.set(false)"
        (navigate)="selectedItem.set($event)"
        [techmagicHide]="techmagicHide()" />
}
